<template>
  <el-row class="mr-b20" slot="content" >
    <el-table-wrapper height="750px" v-loading="isLoading" ref="histTable" :data="maintenanceHistData" :columns="columns" style="width:100%;" :pagination="false"
      :total="total" :column-default="columnDefault" @condition-change="onTableConditionChange" >
    </el-table-wrapper>
  </el-row>
</template>

<script>
import reportApi from '@/api/report/report';
import { columnDefault } from '@/constants/table';

export default {
  name: 'WMaintenanceHistSummaryView',
  props: {
    popupParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columnDefault,
      maintenanceHistData: [],
      maintenanceHistDataOrg: [],
      total: null,
      isLoading: false,
      columns: [
        { prop: 'customerName', label: '고객사', width: '100px', remoteProp: 'customer_name' },
        { prop: 'serviceName', label: '서비스', width: '100px', remoteProp: 'service_name' },
        { prop: 'managegroupName', label: '기능별 분류', width: '100px', remoteProp: 'managegroup_name' },
        { prop: 'objCount', label: '점검 대상', width: '100px', remoteProp: 'obj_count' },
        { prop: 'normalCount', label: '정상', width: '100px', remoteProp: 'normal_count' },
        { prop: 'errorCount', label: '추가 점검 대상', width: '100px', remoteProp: 'error_count' },
        { prop: 'remark', label: '특이사항', remoteProp: 'remark' },
      ],
    };
  },
  methods: {
    loadData() {
      const params = {
        reportId: this.popupParams.reportId,
        generateDate: this.popupParams.generateDate,
      };

      if (this.isLoading === false) {
        this.isLoading = true;
      }

      reportApi.getMaintenanceSummary(params).then((response) => {
        if (response.data.success) {
          this.maintenanceHistData = response.data.data;
        }
        this.isLoading = false;
      });
    },
    exportExcel() {
      reportApi.generateReport(this.popupParams);
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/popup/components/MaintenanceHistSummaryView.vue